module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_06_american-village-8801a558d9437d1aa67f914ac002c7c4.jpg";